import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import TextInput from '../../ui/TextInput/TextInput'
import ActionButton from '../../ui/ActionButton/ActionButton'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

function OtpForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
  } = props

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        <TextInput
          name="code"
          type="text"
          placeholder="Enter 6-digit code"
          maxLength={6}
          initialValue={values.code}
          error={errors.code}
          touched={touched.code}
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="off"
          floatingLabel={false}
          centered
        />
        <ButtonWrapper>
          <BlockButton type="submit" variant="primary" disabled={!isValid}>
            Next
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

OtpForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

OtpForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default OtpForm
